export const GET_AREAS_BY_CHAIN = 'GET_AREAS_BY_CHAIN'
export const GET_AREAS_BY_CHAIN_ERR = 'GET_AREAS_BY_CHAIN_ERR'

export const ADD_AREA_TO_CHAIN_START = 'ADD_AREA_TO_CHAIN_START'
export const ADD_AREA_TO_CHAIN = 'ADD_AREA_TO_CHAIN'
export const ADD_AREA_TO_CHAIN_END = 'ADD_AREA_TO_CHAIN_END'
export const ADD_AREA_TO_CHAIN_ERR = 'ADD_AREA_TO_CHAIN_ERR'